import { List, ListItem, styled, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import { useTranslation } from "react-i18next";

export const ListWrapper = styled(Box)(({ theme }) => ({
    paddingBottom: "16px",
    [theme.breakpoints.up("lg")]: {
        paddingRight: "145px",
    },
}));

const listItem = {
    width: "97%",
    paddingRight: "8px",
    "&::marker": {
        alignSelf: "center",
    },
    display: "list-item",
    listStyle: "disc",
    fontSize: "10px",
    marginLeft: "23px",
};

const dashListItem = {
    width: "97%",
    paddingRight: "0px",
    "&::before": {
        content: '"-"',
        marginLeft: "36px",
        alignSelf: "center",
    },
};

const GroupLifeInsuranceText = (props: {
    valueOfSubtitle: string;
    listItemWithSublist?: string;
    paragraphValues?: string[];
    listValues?: string[];
    sublistValues?: string[];
}) => {
    const { valueOfSubtitle, listItemWithSublist, paragraphValues, listValues, sublistValues } = props;
    const { t } = useTranslation();

    return (
        <ListWrapper>
            <Box>
                <Typography variant={"subtitle1"} sx={{ textAlign: "justify", height: "30px" }}>
                    {t(valueOfSubtitle)}
                </Typography>
            </Box>
            <Box>
                {paragraphValues?.map((paragraphValue, index) => (
                    <Typography sx={{ paddingTop: "16px" }} variant={"body1"} key={index}>
                        {t(paragraphValue)}
                    </Typography>
                ))}
            </Box>
            <Box sx={{ paddingBottom: "8px" }}>
                <List sx={{ paddingBottom: "0px" }}>
                    {listValues?.map((listValue, index) => (
                        <ListItem key={index} sx={listItem}>
                            <Typography variant={"body1"}> {t(listValue)}</Typography>
                        </ListItem>
                    ))}
                </List>
                {sublistValues && listItemWithSublist && (
                    <List sx={{ paddingBottom: "0px", paddingTop: "0px" }}>
                        {sublistValues?.map((sublistValue, index) => (
                            <ListItem sx={dashListItem} key={index}>
                                <Typography ml={"18px"} variant={"body1"}>
                                    {t(sublistValue)}
                                </Typography>
                            </ListItem>
                        ))}
                    </List>
                )}
            </Box>
        </ListWrapper>
    );
};
export default GroupLifeInsuranceText;
